import { createContext, useContext, useEffect, useRef, useState } from "react";
import { Logo } from "@/components/Logo";

const KEY = "dg_age_verified";
const AgeContext = createContext({ verified: true });
export const useAge = () => useContext(AgeContext);

const readVerified = () => {
  try { return sessionStorage.getItem(KEY) === "yes"; } catch { return false; }
};

export const AgeProvider = ({ children }) => {
  const [verified, setVerified] = useState(readVerified);
  const [denied, setDenied] = useState(false);
  const yesRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = verified ? "" : "hidden";
    if (!verified) yesRef.current?.focus();
    return () => { document.body.style.overflow = ""; };
  }, [verified]);

  const confirm = () => {
    try { sessionStorage.setItem(KEY, "yes"); } catch { /* storage blocked */ }
    setVerified(true);
  };

  return (
    <AgeContext.Provider value={{ verified }}>
      {children}
      {!verified && (
        <div role="dialog" aria-modal="true" aria-labelledby="age-title" data-testid="age-gate" className="on-dark grain fixed inset-0 z-[100] flex items-center justify-center bg-brand-ink/95 p-4 backdrop-blur-sm">
          <div className="relative w-full max-w-md border border-white/10 bg-[#161616] p-8 text-center shadow-[0_16px_48px_rgba(0,0,0,0.5)] sm:p-10">
            <Logo light className="mx-auto mb-8 h-14" />
            <p className="eyebrow-lime">Adults only</p>
            <h2 id="age-title" className="mt-3 font-display text-3xl font-black tracking-tight text-white">Are you 21 or older?</h2>
            <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-testid={denied ? "age-gate-denied-message" : undefined}>
              {denied
                ? "Sorry — you must be 21 or older to visit this site."
                : "District Gaslight is for adults 21+. Purchases require a valid ID and a medical cannabis patient registration."}
            </p>
            <div className="mt-8 grid gap-3">
              <button ref={yesRef} type="button" onClick={confirm} data-testid="age-gate-confirm-button" className="btn-lime w-full">Yes, I'm 21+</button>
              <button type="button" onClick={() => setDenied(true)} data-testid="age-gate-deny-button" className="btn-outline-light w-full">No, I'm under 21</button>
            </div>
          </div>
        </div>
      )}
    </AgeContext.Provider>
  );
};
